import { LayoutColumn } from "./LayoutColumn";

export class LayoutBlock {
    public Id: string;
    public BlockSize: number;
    public BlockTitle: string;
    public BlockType: string;
    public Hidden: boolean = false;
    public Locked: boolean = false;
    public Columns: LayoutColumn[];
    public EntityName: string;
    public BlockBorderColor: string;
    public UserPinned: boolean = false;
    public Collapsed: boolean = false;
}
